import PropTypes from 'prop-types'
import { Component } from 'react'
import { Bar, BarChart, Cell, LabelList, Tooltip, XAxis, YAxis } from 'recharts'

const MAX_LABEL_LENGTH = 30

class HorizontalBarChart extends Component<any, any> {
  static displayName = 'HorizontalBarChart'

  state = {
    activeLabel: {
      name: null
    }
  }

  static propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    data: PropTypes.array.isRequired,
    nameKey: PropTypes.string,
    dataKey: PropTypes.string,
    tooltip: PropTypes.func
  }

  static defaultProps = {
    animate: false,
    label: true,
    tooltip: false,
    colors: [
      '#E04264',
      '#534BB4',
      '#00B3E6',
      '#00BDAC',
      '#EA8C0B',
      '#BD10E0',
      '#8BC849',
      '#8BC849',
      '#4A90E2',
      '#FFCE2D',
      '#9B9B9B'
    ],
    dataKey: 'value',
    nameKey: 'name',
    height: 370,
    width: 400,
    className: 'horizontal-bar-chart'
  }

  maxChartValue = (dataMax: any) => {
    if (dataMax < 10) return 10
    return Math.round(dataMax * 1.8)
  }

  onMouseEnterChart = (data: any) => {
    this.setState({ activeLabel: { name: data.name } })
  }

  onMouseLeaveChart = () => {
    this.setState({ activeLabel: { name: null } })
  }
  determineSectionOpacity = (entry: any, activeSection: any) => {
    if (!activeSection.name) return { transition: '500ms', opacity: '100%' }
    else if (activeSection.name === entry.name) return { transition: '500ms', opacity: '100%' }
    return { transition: '500ms', opacity: '20%' }
  }

  customLabel = (props: any) => {
    const item = this.props.data[props.index]
    const percentage = item.detail.percent < 1 ? `< 1%` : `${Math.round(item.detail.percent)}%`
    const displayText = `${percentage}  ${item.name}`
    return (
      <text style={{ fontSize: '0.85rem', fill: 'black' }} x={props.x + props.width + 10} y={props.y + 20}>
        {displayText.length > MAX_LABEL_LENGTH
          ? `${displayText.slice(0, Math.max(0, MAX_LABEL_LENGTH - 3))}...`
          : displayText}
      </text>
    )
  }

  //{entry.value.length > labelWidth ? `${entry.value.substring(0, labelWidth - 3)}...` : entry.value}

  render() {
    const { className, width, height, data, animate, colors, dataKey, nameKey, tooltip } = this.props
    const { activeLabel } = this.state
    return (
      <BarChart
        className={className}
        height={height}
        width={width}
        layout="vertical"
        data={data}
        barCategoryGap={1}
        style={{ paddingTop: '20px' }}
      >
        {tooltip && <Tooltip content={tooltip} cursor={false} />}
        <XAxis type="number" dataKey={dataKey} domain={[0, (dataMax: any) => this.maxChartValue(dataMax)]} hide />
        <YAxis type="category" dataKey={nameKey} hide />
        <Bar
          dataKey={dataKey}
          isAnimationActive={animate}
          onMouseEnter={this.onMouseEnterChart}
          onMouseLeave={this.onMouseLeaveChart}
        >
          {/* @ts-expect-error */}
          <LabelList content={this.customLabel} position="right" />
          {data.map((entry: any, index: any) => (
            <Cell
              style={this.determineSectionOpacity(entry, activeLabel)}
              className="pointer"
              key={entry}
              fill={colors[index % colors.length]}
            />
          ))}
        </Bar>
      </BarChart>
    )
  }
}

export default HorizontalBarChart
